import Page from "../../components/Page";
import {Button, Grid, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import {useNavigate} from "react-router-dom";

export default function CreateInvoicePage() {
  const navigate = useNavigate();

  return (
    <Page title="Nouvelle facture">
      <Grid>
        <Button
          startIcon={<ArrowBackIcon/>}
          onClick={() => navigate(-1)}
          style={{marginLeft: ".5rem", color: "black"}}
        >
          Test
        </Button>
        <Grid>
          <Typography style={{marginLeft: "1.2rem"}} variant="h6">

          </Typography>
        </Grid>
      </Grid>
    </Page>
  )
}